// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__lFIcB","left":"StickyBox_left__1lrY0","right":"StickyBox_right__3mRPv"};